import React, { useEffect, useState } from "react";
import { UserResponse } from "../services/api.response.service";
import { Dropdown } from "react-bootstrap";
import { RouteEndpoints } from "../services/route.service";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { auth } from "../services/firebase.service";
import { signOut } from "firebase/auth";
import Auth from "../redux/actions/auth.action";

interface props {
  user: UserResponse;
}

const SidebarProfile = ({ user }: props) => {
  const dispatch = useDispatch();
  let location = useLocation();

  const [downloadLink, setDownloadLink] = useState<string>();
  useEffect(() => {
    setDownloadLink(
      /Android/.test(navigator.userAgent)
        ? "https://play.google.com/store/apps/details?id=equinos.e_campus_1"
        : "https://apps.apple.com/gh/app/ecampus-app/id1009589983"
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {" "}
      <Dropdown className="d-flex align-items-center">
        <Dropdown.Toggle
          id="dropdown-basic"
          className="profile-container dropdown-toggle d-flex gap-2 align-items-center px-3"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <div
            className="profile-picture"
            style={{ backgroundImage: `url(${user?.image_url})` }}
          ></div>
          <div className="user-name">
            {user.first_name} {user.last_name}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            as={Link}
            to={RouteEndpoints.PROFILE}
            className={`${
              location.pathname === "/profile" ? "active" : ""
            } d-flex align-items-center mt-3`}
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.19163 9.72427L12.1916 2.72427L21.1916 9.72427V20.7243C21.1916 21.2547 20.9809 21.7634 20.6058 22.1385C20.2308 22.5136 19.7221 22.7243 19.1916 22.7243H5.19163C4.66119 22.7243 4.15249 22.5136 3.77741 22.1385C3.40234 21.7634 3.19163 21.2547 3.19163 20.7243V9.72427Z"
                stroke="#2E2E2E"
                strokeWidth="2.46471"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.19168 22.7243V12.7243H15.1917V22.7243"
                stroke="#2E2E2E"
                strokeWidth="2.46471"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Profile
          </Dropdown.Item>
          <Dropdown.Item
              onClick={() => {
                window.location.href = "https://ecampus.camp/support";
              }}
            className="d-flex align-items-center"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.8367 1.88277H15.8367C15.2642 1.88043 14.7091 2.07948 14.2685 2.4451C13.8279 2.81072 13.53 3.31963 13.4267 3.88277L12.5067 8.93277C12.4431 9.28461 12.4577 9.64612 12.5492 9.99173C12.6408 10.3373 12.8073 10.6586 13.0367 10.9328C13.2675 11.2071 13.5552 11.4279 13.8798 11.5798C14.2044 11.7318 14.5583 11.8113 14.9167 11.8128H17.8367L17.5867 12.4728C17.4022 12.9621 17.3381 13.4887 17.3998 14.0081C17.4616 14.5275 17.6474 15.0243 17.9416 15.4568C18.2358 15.8892 18.6297 16.2446 19.09 16.4927C19.5504 16.7409 20.0638 16.8747 20.5867 16.8828C20.7808 16.8843 20.9711 16.8293 21.1345 16.7246C21.2978 16.6198 21.4272 16.4698 21.5067 16.2928L23.7467 11.2328C23.7977 11.1225 23.8282 11.0039 23.8367 10.8828V2.88277C23.8367 2.61756 23.7314 2.3632 23.5438 2.17567C23.3563 1.98813 23.1019 1.88277 22.8367 1.88277ZM21.8367 10.6128L20.0067 14.7428C19.8281 14.6456 19.6742 14.5087 19.5567 14.3428C19.439 14.1762 19.3646 13.9829 19.3402 13.7805C19.3158 13.578 19.3421 13.3726 19.4167 13.1828L19.7967 12.1828C19.8967 11.9234 19.9308 11.6433 19.8959 11.3676C19.8609 11.0918 19.7582 10.829 19.5967 10.6028C19.4377 10.3774 19.2263 10.1941 18.9807 10.0686C18.735 9.94318 18.4625 9.8794 18.1867 9.88277H14.8967C14.8303 9.88296 14.7646 9.86875 14.7042 9.84113C14.6438 9.81351 14.5901 9.77313 14.5467 9.72277C14.4691 9.61614 14.4368 9.48315 14.4567 9.35277L15.3767 4.35277C15.3724 4.2908 15.3813 4.22861 15.4027 4.17031C15.4242 4.112 15.4578 4.0589 15.5012 4.0145C15.5447 3.9701 15.597 3.93541 15.6549 3.91271C15.7127 3.89 15.7747 3.8798 15.8367 3.88277H21.8367V10.6128ZM10.7767 13.9328H7.88673L8.13673 13.2728C8.31863 12.7805 8.37901 12.2517 8.31275 11.7311C8.24648 11.2105 8.05553 10.7137 7.75611 10.2827C7.4567 9.85174 7.05767 9.49942 6.59293 9.2557C6.1282 9.01197 5.6115 8.88404 5.08673 8.88277C4.89267 8.88124 4.70236 8.93621 4.539 9.04097C4.37564 9.14573 4.24629 9.29576 4.16673 9.47277L1.92673 14.5328C1.86943 14.6585 1.83878 14.7947 1.83673 14.9328V22.9328C1.83673 23.198 1.94209 23.4523 2.12962 23.6399C2.31716 23.8274 2.57151 23.9328 2.83673 23.9328H9.83673C10.4093 23.9351 10.9644 23.7361 11.4049 23.3704C11.8455 23.0048 12.1435 22.4959 12.2467 21.9328L13.1667 16.9328C13.2303 16.5809 13.2158 16.2194 13.1242 15.8738C13.0326 15.5282 12.8662 15.2069 12.6367 14.9328C12.4199 14.639 12.1406 14.3969 11.819 14.224C11.4974 14.0511 11.1414 13.9516 10.7767 13.9328ZM10.2967 21.5128C10.2796 21.6205 10.223 21.718 10.138 21.7864C10.053 21.8547 9.94563 21.8891 9.83673 21.8828H3.83673V15.1528L5.66673 11.0228C5.84534 11.12 5.99928 11.2568 6.11673 11.4228C6.23441 11.5894 6.30882 11.7826 6.33326 11.9851C6.3577 12.1876 6.3314 12.393 6.25673 12.5828L5.87673 13.5828C5.77676 13.8421 5.74271 14.1222 5.77761 14.398C5.81252 14.6737 5.91529 14.9365 6.07673 15.1628C6.23348 15.3919 6.44394 15.5791 6.68973 15.7081C6.93552 15.8371 7.20915 15.9039 7.48673 15.9028H10.7767C10.8432 15.9026 10.9088 15.9168 10.9693 15.9444C11.0297 15.972 11.0834 16.0124 11.1267 16.0628C11.2044 16.1694 11.2367 16.3024 11.2167 16.4328L10.2967 21.5128Z"
                fill="#3C3C3B"
              />
            </svg>
            Feedback
          </Dropdown.Item>
          <Dropdown.Item
              onClick={() => {
                window.location.href = "https://ecampus.camp/support";
              }}
            className="d-flex align-items-center"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.8367 22.8828C18.3596 22.8828 22.8367 18.4056 22.8367 12.8828C22.8367 7.3599 18.3596 2.88275 12.8367 2.88275C7.31388 2.88275 2.83673 7.3599 2.83673 12.8828C2.83673 18.4056 7.31388 22.8828 12.8367 22.8828Z"
                stroke="#3C3C3B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.92673 9.88277C10.1618 9.21444 10.6259 8.65088 11.2367 8.2919C11.8475 7.93293 12.5656 7.80171 13.2639 7.92148C13.9622 8.04126 14.5955 8.4043 15.0518 8.9463C15.5081 9.4883 15.7578 10.1743 15.7567 10.8828C15.7567 12.8828 12.7567 13.8828 12.7567 13.8828"
                stroke="#3C3C3B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.8367 16.8828V17.3828"
                stroke="#3C3C3B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Support
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              dispatch(Auth.logout());
              signOut(auth);
            }}
            className="d-flex align-items-center"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.9285 17.7242L21.9285 12.7242L16.9285 7.72424"
                stroke="#3C3C3B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.9285 12.7242H9.92853"
                stroke="#3C3C3B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.92853 21.7242H5.92853C5.39809 21.7242 4.88939 21.5135 4.51431 21.1385C4.13924 20.7634 3.92853 20.2547 3.92853 19.7242V5.72424C3.92853 5.19381 4.13924 4.6851 4.51431 4.31003C4.88939 3.93496 5.39809 3.72424 5.92853 3.72424H9.92853"
                stroke="#3C3C3B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Log out
          </Dropdown.Item>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={downloadLink!}
            className="download-container position-absolute bottom-0 d-flex align-items-center justify-content-center"
          >
            <div className="download-app d-flex align-items-center justify-content-center text-nowrap">
              Download Mobile App
            </div>
          </a>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default SidebarProfile;
